// ADDED
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Select } from "../../../../../common/Select";
import { LeaveIncentiveBatchStatus } from "../../../../../utils/enums";

const MONTHS = [
  { value: 1, label: "January" }, { value: 2, label: "February" },
  { value: 3, label: "March" }, { value: 4, label: "April" },
  { value: 5, label: "May" }, { value: 6, label: "June" },
  { value: 7, label: "July" }, { value: 8, label: "August" },
  { value: 9, label: "September" }, { value: 10, label: "October" },
  { value: 11, label: "November" }, { value: 12, label: "December" }
];

const LeaveIncentiveBatchAddEditModal = ({ isOpen, onClose, selectedItem, onSave, years }) => {
  const [form, setForm] = useState({ month: "", year: "" });
  const isDraft = !selectedItem || selectedItem.status === LeaveIncentiveBatchStatus.DRAFT;

  useEffect(() => {
    if (selectedItem) {
      setForm({ month: selectedItem.month, year: selectedItem.year });
    } else {
      setForm({ month: new Date().getMonth() + 1, year: new Date().getFullYear() });
    }
  }, [selectedItem, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white w-full max-w-md rounded-lg shadow-xl">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-lg font-bold">{selectedItem ? "Edit" : "Create"} Batch</h2>
          <button onClick={onClose} className="border-none bg-transparent cursor-pointer"><CloseIcon /></button>
        </div>
        <div className="p-6 space-y-4">
          <Select
            label="Year"
            value={form.year}
            options={years}
            onChange={(e) => setForm({ ...form, year: Number(e.target.value) })}
            isDisabled={!isDraft}
          />
          <Select
            label="Month"
            value={form.month}
            options={MONTHS}
            onChange={(e) => setForm({ ...form, month: Number(e.target.value) })}
            isDisabled={!isDraft}
          />
        </div>
        <div className="flex justify-end gap-2 p-4 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
          {isDraft && (
            <button onClick={() => onSave(form)} className="px-6 py-2 bg-blue-600 text-white rounded">
              Save
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaveIncentiveBatchAddEditModal;